import { z } from 'zod';

export const SubscriptionDetails = z.object({
  subscriptionId: z.string(),
  subscriptionPaidUntilDate: z.string().nullable(),
  subscriptionType: z.enum(['Trial', 'Bundled', 'Cluey+']).nullable(),
  subscriptionPrice: z.number(),
  subscriptionStartDate: z.string().nullable(),
  subscriptionEndDate: z.string().nullable(),
  subscriptionDiscountDuration: z.number().nullable(),
  subscriptionDiscountPercentage: z.number().nullable(),
  subscriptionStatus: z.enum(['Active', 'Cancelled']).nullable(),
});
export type SubscriptionDetails = z.infer<typeof SubscriptionDetails>;

export const Subscription = z.object({
  studentId: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  yearLevel: z.string(),
  subscriptions: z.array(SubscriptionDetails),
});
export type Subscription = z.infer<typeof Subscription>;

export const ESSLRecord = z.object({
  id: z.number(),
  actionC: z.enum([
    'ClueyPlus Signup',
    'ClueyPlus Apply Discount',
    'ClueyPlus Trial Conversion',
    'ClueyPlus Cancel',
    'ClueyPlus Bundle Signup',
  ]),
  billingAccountC: z.string(),
  createddate: z.string(),
  enrolmentC: z.string().nullable(),
  isdeleted: z.boolean(),
  sfid: z.string(),
  startDateTimeC: z.string(),
  statusC: z.enum(['To Process', 'Processed', 'Processing', 'Error']),
  studentAccountC: z.string().nullable(),
});
export type ESSLRecord = z.infer<typeof ESSLRecord>;
